__turbopack_context__.v({
  "clear": "history-search-bar-module__CuBqwa__clear",
  "input": "history-search-bar-module__CuBqwa__input",
  "inputShell": "history-search-bar-module__CuBqwa__inputShell",
  "results": "history-search-bar-module__CuBqwa__results",
  "resultsVisible": "history-search-bar-module__CuBqwa__resultsVisible",
  "state": "history-search-bar-module__CuBqwa__state",
  "wrapper": "history-search-bar-module__CuBqwa__wrapper",
});
